import { useEffect, useState } from "react";
import { Alert, Table } from "react-bootstrap";
import { ReportMasthead } from "../components/reports/ReportDocument.jsx";
import RulesHelp from "../components/shared/RulesHelp.jsx";
import { getCompletionsReport } from "../services/apiClient.js";
import { formatDate, todayInput } from "../utils/date.js";
import "../styles/home.css";

// Badge Completions report (docs/badge-activity-tracking.md): needs-attention
// badges CLEARED, per person, over a period. Reads the badge_events log — output,
// not presence. "System" = clears that happened off-page (no one to credit).
//
// Dressed as a DOCUMENT (report-document.css) and PORTRAIT: three columns.
const PERIODS = [
  ["hour", "Last hour"],
  ["today", "Today"],
  ["week", "This week"],
  ["month", "This month"],
];

function CompletionsReportPage() {
  const [period, setPeriod] = useState("today");
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    setReport(null);
    getCompletionsReport(period)
      .then(setReport)
      .catch((err) => setError(err.response?.data?.error || "Unable to load the completions report."));
  }, [period]);

  const periodLabel = (PERIODS.find(([v]) => v === period) || [])[1] || "";

  return (
    <section className="page-panel">
      {/* App chrome: the document carries its own masthead (report-document.css). */}
      <div className="d-flex flex-wrap align-items-center column-gap-4 row-gap-2 no-print">
        <div className="page-heading">
          <h2>Completions <RulesHelp topic="completions" /></h2>
        </div>
        <div className="btn-group btn-group-sm ms-auto" role="group" aria-label="Period">
          {PERIODS.map(([value, label]) => (
            <button
              key={value}
              type="button"
              className={`btn btn-sm ${period === value ? "btn-primary" : "btn-outline-secondary"}`}
              onClick={() => setPeriod(value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {error ? <Alert variant="danger">{error}</Alert> : null}
      {!report ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <div className="report-doc border rounded">
          <ReportMasthead
            report="Completions"
            title={periodLabel}
            subtitle={`Grayburn Property Services · as at ${formatDate(todayInput())}`}
          />
          <div className="report-body">
        <div className="small text-muted pb-2">
          {report.total} badge{report.total === 1 ? "" : "s"} cleared by{" "}
          {report.users.length} {report.users.length === 1 ? "person" : "people"}
        </div>
        <Table striped bordered hover size="sm" className="mb-0 align-middle report-table">
          <thead className="table-surface">
            <tr>
              <th>Project Co-Ordinator</th>
              <th className="text-end" style={{ width: 120 }}>Completed</th>
              <th>Badges cleared</th>
            </tr>
          </thead>
          <tbody>
            {report.users.map((u) => (
              <tr key={u.user_id ?? "system"}>
                <td className="text-nowrap">{u.name}</td>
                <td className="text-end fw-semibold">{u.total}</td>
                <td>{u.rules.map((r) => `${r.label} ×${r.count}`).join(" · ")}</td>
              </tr>
            ))}
            {report.users.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center text-muted">
                  No completions recorded in this period yet.
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
          </div>
        </div>
      )}
    </section>
  );
}

export default CompletionsReportPage;
